import { LockStatus } from '../types/lock';
import { HTLCStatus } from '../types/htlc-status';
export function resolveHTLCStatus(input) {
    const { sourceDetails, solverLockDetails, timelockExpired, secretRevealed, manualClaimRequired, destRedeemTxId } = input;
    const userLocked = !!sourceDetails?.sender;
    const solverLocked = !!solverLockDetails?.sender;
    const redeemCompleted = solverLockDetails?.status === LockStatus.Redeemed || destRedeemTxId;
    const refunded = sourceDetails?.status === LockStatus.Refunded;
    if (redeemCompleted)
        return HTLCStatus.RedeemCompleted;
    else if (manualClaimRequired)
        return HTLCStatus.ManualClaimRequired;
    else if (refunded)
        return HTLCStatus.Refunded;
    else if (timelockExpired && !redeemCompleted)
        return HTLCStatus.TimelockExpired;
    else if ((secretRevealed || sourceDetails?.secret) && sourceDetails)
        return HTLCStatus.SecretRevealed;
    else if (solverLocked && !sourceDetails?.secret && sourceDetails)
        return HTLCStatus.SolverLockDetected;
    else if (userLocked)
        return HTLCStatus.UserLocked;
    else
        return HTLCStatus.Initial;
}
